/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Unseat_TitleInputs */



/**
* | output |
* | --- |
* | "Unseat player" |
*
* @param {Rounds_Unseat_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_unseat_title = /** @type {((inputs?: Rounds_Unseat_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Unseat_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer le joueur de la table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar jugador del asiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover jogador da mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi giocatore dal tavolo")
	return /** @type {LocalizedString} */ ("Unseat player")
});